import { Injectable } from '@angular/core';
import { HttpRequestPayload, IHttpSuccessPayload } from '@core/models';
import { HttpProviderService } from '@core/service';
import { map, Observable, of } from 'rxjs';

@Injectable()
export class CurrencyService {
  constructor(private _httpProvider: HttpProviderService) {}

  fetchCurrency(): Observable<any> {
    const request: HttpRequestPayload = {
      method: 'GET',
      resource: '/currency',
    };

    return this._httpProvider.invokeApi(request).pipe(
      map((res: IHttpSuccessPayload<any>) => {
        return res.body.currency;
      })
    );
  }

  getNotesOrCash(): Observable<any> {
    const request: HttpRequestPayload = {
      method: 'GET',
      resource: '',
    };
    return of([
      {
        id: 'N',
        text: 'Notes',
      },
      {
        id: 'C',
        text: 'Coins',
      },
    ]);
  }

  fetchDenomination(currency: string, noteOrCoin: string): Observable<any> {
    const request: HttpRequestPayload = {
      method: 'GET',
      resource: '/denominationdtls',
      queryParams: [
        {
          key: 'currencyCode',
          value: currency,
        },
        {
          key: 'moneyType',
          value: noteOrCoin,
        },
        {
          key: 'inUse',
          value: 'Y',
        },
        {
          key: 'lookup',
          value: 1,
        },
      ],
    };
    return this._httpProvider.invokeApi(request).pipe(
      map((res: IHttpSuccessPayload<any>) => {
        return res.body ? res.body.Data : of([]);
      })
    );
  }
}
